var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('gj-button',{attrs:{"type":"text"},on:{"click":_vm.clickOrder}},[_vm._v(_vm._s(_vm.orderId))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }